import 'babel-polyfill';
import 'scss/App.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import App from 'components/App';
import getFeature from 'helpers/getFeature';
import getAppsettings from 'helpers/getAppSettings';
import { receivedAwsCredentials } from 'redux-modules/auth/actions';
import store, { history } from './store';

async function loadLoginConfig() {
  if (window.hstreamLoginConfig) {
    return window.hstreamLoginConfig;
  }

  if (window.hstreamLoginConfigPromise) {
    try {
      const config = await window.hstreamLoginConfigPromise;
      if (config) {
        return config;
      }
    } catch (err) {
      // Fall through to empty config when runtime config fails to load.
    }
  }

  const config = {};
  window.hstreamLoginConfig = config;
  return config;
}

async function initializeApp() {
  const config = await loadLoginConfig();
  window.hstreamLoginConfig = config;

  // Get feature flags
  try {
    const feature = await getFeature();
    let getMobilePromptFeature = 0;
    let getPasswordComplexityFeature = 0;
    for (let index = 0; index < feature.length; index++) {
      if (feature[index].featureCode == "Password_Complexity_Rules") {
        getPasswordComplexityFeature = feature[index].isActive;
      }
      if (feature[index].featureCode == "Mobile_Prompt") {
        getMobilePromptFeature = feature[index].isActive;
      }
    }
    config.featurePasswordComplexity = getPasswordComplexityFeature;
    config.featureMobilePrompt = getMobilePromptFeature;
  } catch (err) {
    config.featurePasswordComplexity = 0;
    config.featureMobilePrompt = 0;
  }

  // Get app settings
  try {
    const appSettings = await getAppsettings();
    let getMobilePromptConfigurationDaysAppSetting = 0;
    let getVerificationCodeValidityPeriodAppSetting = 0;
    for (let index = 0; index < appSettings.length; index++) {
      if (appSettings[index].key == "MobilePromptConfigurationDays") {
        if (isNaN(parseInt(appSettings[index].value))) {
          if (!isNaN(parseInt(appSettings[index].defaultValue))) {
            getMobilePromptConfigurationDaysAppSetting = appSettings[index].defaultValue;
          }
        }
        getMobilePromptConfigurationDaysAppSetting = appSettings[index].value;
      }
      if (appSettings[index].key == "VerificationCodeValidityPeriod") {
        if (isNaN(parseInt(appSettings[index].value))) {
          if (!isNaN(parseInt(appSettings[index].defaultValue))) {
            getVerificationCodeValidityPeriodAppSetting = appSettings[index].defaultValue;
          }
        }
        getVerificationCodeValidityPeriodAppSetting = appSettings[index].value;
      }
    }
    config.appSettingMobilePromptConfigurationDays = parseInt(getMobilePromptConfigurationDaysAppSetting);
    config.appSettingVerificationCodeValidityPeriod = parseInt(getVerificationCodeValidityPeriodAppSetting);
  } catch (err) {
    config.appSettingMobilePromptConfigurationDays = 0;
    config.appSettingVerificationCodeValidityPeriod = 0;
  }

  store.dispatch(receivedAwsCredentials(config));
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App config={config} />
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
  );
}

initializeApp();
